import Glide, {Swipe, Controls, Breakpoints, Autoplay } from '@glidejs/glide/dist/glide.modular.esm'

const doc = document;
const SLIDER_CLASS = '.glide';
const AUTOPLAY_SEC = 10000;

export default class Heroslider  {
    
  constructor() {
    this.render();
  }

  render(slider) {    
    if(doc.querySelector(SLIDER_CLASS)){
      new Glide(SLIDER_CLASS, {
          autoplay: AUTOPLAY_SEC
      }).mount({ Swipe, Controls, Breakpoints, Autoplay });
    }
  }
  
}